module.exports = __webpack_public_path__ + "img/audio-light.3edc0292.svg";